import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { FaDownload } from "react-icons/fa";

const AuditProtocolScoringExcel = ({
  auditData = auditData || {},
  protocolData = protocolData || {},
  sheetNames = sheetNames || [
    "Unit Details",
    "Audit details",
    "Protocol details",
    "Scoring details",
    "Areas of Concern",
    "PY-Areas of Concern",
    "FSSC Findings",
    "PY-FSSC Findings",
  ],
  fileName = fileName || "Report",
  className = className || "",
  exportPosition,
  color = color || "FF0000", // Default red header
  type,
  scoringData = scoringData || {},
  protocolType = protocolType || "",
  auditFocusArea = [], // Array for audit focus areas
  protocolFocusArea = {}, // Object for protocol focus areas
  additionalAttendees = [],
  versioning,
  isCertification,
  sendback,
  unitDetails,
  correctionDate,

}) => {
  let version = auditData?.version;
  console.log("version",version)

  console.log("correctionDate",correctionDate)
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const columnWidth = { wch: 20 };
  const unitDetailsCols = [
    { wch: 15 }, // Unit Type
    { wch: 25 }, // Manufacturing Code (3 Letter) (if applicable)
    { wch: 35 }, // Quality Manager or Lead Auditee
    { wch: 40 }, // Quality Manager or Lead Auditee Email
    { wch: 35 }, // Current Third Party Certifications Held
    { wch: 30 }, // Parent Unit Name
    { wch: 20 }, // Unit Country
    { wch: 20 }, // Unit Region
    { wch: 25 }, // CB Name
    { wch: 25 }, // Enterprise
    { wch: 30 }, // Responsible Segment
    { wch: 30 }, // Responsible Division
    { wch: 25 }, // Business Unit
    { wch: 30 }, // Sub Business Unit
    { wch: 30 }, // Off-Site Activities (if applicable)
    { wch: 30 }, // Type of Off-Site Activity
    { wch: 30 }, // Is Location Currently Audited?
    { wch: 30 }, // Site Name
    { wch: 35 }, // If Yes - Who is Auditing Location
  ];

  // Define column widths for both sheets
  const auditCols = [
    { wch: 25 }, // audit_criteria
    { wch: 20 }, // audit_delivery
    { wch: 15 }, // audit_start_date
    { wch: 15 }, // audit_end_date
    { wch: 15 }, // audit_language
    { wch: 15 }, // audit_type
    { wch: 20 }, // cb_office_location
    { wch: 10 }, // is_fssc_conjunction
    { wch: 15 }, // lead_auditor
    { wch: 10 }, // version
    { wch: 25 }, // focus_area
  ];

  const protocolCols = [
    { wch: 20 }, // protocol_description
    { wch: 20 }, // protocol_description
    { wch: 20 }, // protocol_description
    { wch: 20 }, // protocol_description
    { wch: 20 }, // protocol_description
    { wch: 20 }, // protocol_description
    { wch: 20 }, // protocol_description
    { wch: 20 }, // protocol_description
    { wch: 25 }, // focus_area
  ];

  const areasOfConcernsCols = [
    { wch: 15 }, // Number (#)
    { wch: 35 }, // Standard or Technical Specifications
    { wch: 25 }, // Requirement Reference
    { wch: 35 }, // Details of Nonconformity
    { wch: 30 }, // Evidence of Non-conformity
    { wch: 25 }, // Nonconformity Rating
    { wch: 25 }, // Nonconformance Status
    { wch: 30 }, // Corrective Action Evidence
  ];

  const fsscFindngCols = [
    { wch: 15 }, // Number (#)
    { wch: 35 }, // Standard or Technical Specifications
    { wch: 25 }, // Requirement Reference
    { wch: 35 }, // Details of Nonconformity
    { wch: 30 }, // Evidence of Non-conformity
    { wch: 25 }, // Nonconformity Rating
    { wch: 25 }, // NonConformance Status
    { wch: 30 }, // Evidence Of Correction
  ];

  const PYareasOfConcernsCols = [
    { wch: 15 }, // Number (#)
    { wch: 35 }, // Standard or Technical Specifications
    { wch: 25 }, // Requirement Reference
    { wch: 35 }, // Details of Nonconformity
    { wch: 30 }, // Evidence of Non-conformity
    { wch: 25 }, // Nonconformity Rating
    { wch: 25 }, // NonConformance Status
    { wch: 30 }, // Corrective Action Evidence
  ];

 

  const PYfsscFindingsCols = [
    { wch: 15 }, // Number (#)
    { wch: 35 }, // Standard or Technical Specifications
    { wch: 25 }, // Requirement Reference 
    { wch: 35 }, // Details of Nonconformity
    { wch: 30 }, // Evidence of Non-conformity
    { wch: 25 }, // Nonconformity Rating
    { wch: 25 }, // NonConformance Status
    { wch: 30 }, // Evidence Of Correction
  ];

  function formatDate(dateStr) {
    const date = new Date(dateStr);

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    // Return the formatted date
    return `${day}-${month}-${year}`;
  }

  // Apply styles to the sheet
  const addStyles = (workSheet, color) => {
    // Apply special styling to "Previous Year Non-conformity" heading and column headers
    // Find the row that contains "Previous Year Non-conformity" text
    let previousYearRow = null;
    let headingStartCol = null;
    let headingEndCol = null;
    
    Object.entries(workSheet)
      .filter(([k, v]) => v.v && typeof v.v === 'string' && v.v.includes("Previous Year Non-conformity"))
      .forEach(([k, v]) => {
        const match = k.match(/\d+/);
        const colMatch = k.match(/^([A-Z]+)/);
        if (match && match[0]) {
          const rowNumber = parseInt(match[0]);
          previousYearRow = rowNumber;
          headingStartCol = colMatch[1];
          
          // Style the "Previous Year Non-conformity" heading itself
          v.s = {
            fill: { fgColor: { rgb: "F1634D" } }, // Custom color for Previous Year heading
            alignment: { vertical: "center", horizontal: "center" },
            font: { bold: true, color: { rgb: "FFFFFF" } }, // White bold text
          };
        }
      });

    // Apply custom color to the row after "Previous Year Non-conformity" (which contains the column headers)
    if (previousYearRow) {
      const headerRow = previousYearRow + 2; // Skip one empty row after heading
      
      // Find the end column by looking at the header row
      Object.entries(workSheet)
        .filter(([k]) => {
          const match = k.match(/\d+/);
          if (match && match[0]) {
            const rowNumber = parseInt(match[0]);
            return rowNumber === headerRow;
          }
          return false;
        })
        .forEach(([k, v]) => {
          const colMatch = k.match(/^([A-Z]+)/);
          if (colMatch && colMatch[1]) {
            headingEndCol = colMatch[1];
          }
        });
      
      // Merge cells for the heading row
      if (headingStartCol && headingEndCol) {
        const mergeRange = `${headingStartCol}${previousYearRow}:${headingEndCol}${previousYearRow}`;
        if (!workSheet['!merges']) workSheet['!merges'] = [];
        workSheet['!merges'].push(XLSX.utils.decode_range(mergeRange));
      }
      
      Object.entries(workSheet)
        .filter(([k]) => {
          const match = k.match(/\d+/);
          if (match && match[0]) {
            const rowNumber = parseInt(match[0]);
            return rowNumber === headerRow;
          }
          return false;
        })
        .forEach(([k, v]) => {
          v.s = {
            fill: { fgColor: { rgb: "F1634D" } }, // Custom color for Previous Year headers
            alignment: { vertical: "center", horizontal: "center" },
            font: { bold: true, color: { rgb: "FFFFFF" } }, // White bold text
          };
        });
    }

    // Apply styles to the main header row (columns A-Z, AA, AB, etc.)
    Object.entries(workSheet)
      .filter(([k]) => k.match(/^[A-Z]{1,2}1$/)) // Target all header rows (1st row of each column, including multi-letter columns)
      .forEach(([k, v]) => {
        v.s = {
          fill: { fgColor: { rgb: color } }, // Header background color
          alignment: { vertical: "center", horizontal: "left" },
          font: { bold: true, color: { rgb: "FFFFFF" } }, // White text
        };
      });

    // Apply styles to the data rows (columns A-Z, AA, AB, etc.)
    Object.entries(workSheet)
      .filter(([k]) => k.match(/^[A-Z][2-9]\d*$/)) // Apply styles for other rows (excluding header row)
      .forEach(([k, v]) => {
        // Skip styling if this cell is part of the "Previous Year Non-conformity" heading or its column headers
        const match = k.match(/\d+/);
        if (match && match[0] && previousYearRow) {
          const rowNumber = parseInt(match[0]);
          if (rowNumber === previousYearRow || rowNumber === previousYearRow + 2) {
            return; // Skip styling for these rows as they're already styled above
          }
        }
        
        v.s = {
          alignment: { vertical: "center", horizontal: "left", wrapText: true },
        };
      });

    // Set the same column width for all columns
    // Note: Column widths are now set individually per sheet type
    // This section is removed to allow custom column widths per sheet
  };

  console.log("scoring data in export ", scoringData);

  const exportToExcel = () => {
    if (
      (!unitDetails || Object.keys(unitDetails).length === 0) &&
      (!auditData || Object.keys(auditData).length === 0) &&
      (!protocolData || Object.keys(protocolData).length === 0)
    ) {
      alert("No data to export"); // Show alert if no data is present
      return;
    }

    const formattedUnitDetails = unitDetails?.reduce((acc, item) => {
      acc[item.label] = item.value || "N/A";
      return acc;
    }, {});

    const formattedAdditionalAttendees =
      additionalAttendees.length > 0
        ? additionalAttendees
            .map((attendee) => `${attendee.name}: ${attendee.function}`)
            .join(", ")
        : "N/A";

    // Format Audit Details Data
    let auditFormattedData;

    if (versioning || version !== 1) {
      auditFormattedData = [
        {
          "Audit Criteria": Array.isArray(auditData.audit_criteria)
            ? auditData.audit_criteria.join(", ")
            : auditData.audit_criteria || "N/A",
          "Audit Delivery": auditData.audit_delivery || "N/A",
          "Audit Start Date": auditData.audit_start_date
            ? formatDate(auditData.audit_start_date)
            : "N/A",
          "Audit End Date": auditData.audit_end_date
            ? formatDate(auditData.audit_end_date)
            : "N/A",
          "Audit Language": auditData.audit_language || "N/A",
          "Audit Type":
            auditData.audit_type === "sustaining"
              ? "Sustaining"
              : auditData.audit_type === "gap assessment"
              ? "Gap Assesment"
              : "N/A",
          "CB Office Location": auditData.cb_office_location || "N/A",
          "Is FSSC Conjunction":
            auditData.is_fssc_conjunction === true
              ? "Yes"
              : auditData.is_fssc_conjunction === false
              ? "No"
              : "N/A",
          "Lead Auditor": auditData.lead_auditor || "N/A",
          Version: auditData.version || "N/A",
          "Job Number": auditData.jobnumber || "N/A",
          "Focus Area": auditFocusArea.join(", ") || "N/A", // Add Focus Area column here
          "Additional Attendees": formattedAdditionalAttendees,
          "Corrective Action Date": correctionDate ? formatDate(correctionDate) : "N/A",
        },
      ];
    } else {
      auditFormattedData = [
        {
          "Audit Criteria": Array.isArray(auditData.audit_criteria)
            ? auditData.audit_criteria.join(", ")
            : auditData.audit_criteria || "N/A",
          "Audit Delivery": auditData.audit_delivery || "N/A",
          "Audit Start Date": auditData.audit_start_date
            ? formatDate(auditData.audit_start_date)
            : "N/A",
          "Audit End Date": auditData.audit_end_date
            ? formatDate(auditData.audit_end_date)
            : "N/A",
          "Audit Language": auditData.audit_language || "N/A",
          "Audit Type":
            auditData.audit_type === "sustaining"
              ? "Sustaining"
              : auditData.audit_type === "gap assessment"
              ? "Gap Assesment"
              : "N/A",
          "CB Office Location": auditData.cb_office_location || "N/A",
          "Is FSSC Conjunction":
            auditData.is_fssc_conjunction === true
              ? "Yes"
              : auditData.is_fssc_conjunction === false
              ? "No"
              : "N/A",
          "Lead Auditor": auditData.lead_auditor || "N/A",
          Version: auditData.version || "N/A",
          "Job Number": auditData.jobnumber || "N/A",
          "Focus Area": auditFocusArea.join(", ") || "N/A", // Add Focus Area column here
          "Additional Attendees": formattedAdditionalAttendees,
        },
      ];
    }

    // Format Protocol Details Data
    let protocolFormattedData;

    if (type === "sendback") {
      // For sendback type, use the new dynamic protocolList structure with .value properties
      const protocolEntries = {};
      
      // Add dynamic protocol questions from protocolList
      if (protocolData?.protocolList?.protocolFindings) {
        protocolData.protocolList.protocolFindings.forEach((section) => {
          section.subsection.forEach((subsection) => {
            subsection.questions.forEach((question) => {
              // Create a key that combines section, subsection, and question text
              const key = `${section.section} - ${subsection.subSectionName} - ${question.text}`;
              protocolEntries[key] = question.answer || "N/A";
            });
          });
        });
      }

      // Add focus area entries
      const focusAreaEntries = Object.entries(protocolFocusArea)
        .map(([key, value]) => `${key}: ${value.response}`)
        .join(", ");

      protocolFormattedData = [
        {
          ...protocolEntries,
          "Focus Area": focusAreaEntries || "N/A",
        },
      ];
    } else {
      // For regular type, use the new dynamic protocolList structure
      const protocolEntries = {};
      
      // Add dynamic protocol questions from protocolList
      if (protocolData?.protocolList?.protocolFindings) {
        protocolData.protocolList.protocolFindings.forEach((section) => {
          section.subsection.forEach((subsection) => {
            subsection.questions.forEach((question) => {
              // Create a key that combines section, subsection, and question text
              const key = `${section.section} - ${subsection.subSectionName} - ${question.text}`;
              protocolEntries[key] = question.answer || "N/A";
            });
          });
        });
      }

      // Add focus area entries
      const focusAreaEntries = Object.entries(protocolFocusArea)
        .map(([key, value]) => `${key}: ${value}`)
        .join(", ");

      protocolFormattedData = [
        {
          ...protocolEntries,
          "Focus Area": focusAreaEntries || "N/A",
        },
      ];
    }

    let areasOfConcernFormattedData;
    let PYareasOfConcernFormattedData;
    if (versioning) {
      // For versioning, include evidence of correction
      const currentYearAreas = protocolData?.areasOfConcern?.filter(item => item.isPreviousYear === false) || [];
      const previousYearAreas = protocolData?.areasOfConcern?.filter(item => item.isPreviousYear === true) || [];

      let currentYearData = [];

      if(version !== 1) {

        currentYearData = currentYearAreas.map((item) => ({
          "Number (#)": item.number || "N/A",
          "Standard or Technical Specifications":
            item.standardOrTechnicalSpecification || "N/A",
          "Requirement Reference": item.RequirementReference || "N/A",
          "Details of Nonconformity": item.detailsOfNonconformity || "N/A",
          "Evidence of Non-conformity": item.evidenceOfNonconformity || "N/A",
          "Nonconformity Rating": item.nonconformityRating || "N/A",
          "Nonconformance Status": item.nonConformanceStatus || "N/A",
          "Corrective Action Evidence": item.evidenceOfCorrection || "N/A",
        }));
      }else{
        currentYearData = currentYearAreas.map((item) => ({
          "Number (#)": item.number || "N/A",
          "Standard or Technical Specifications":
            item.standardOrTechnicalSpecification || "N/A",
          "Requirement Reference": item.RequirementReference || "N/A",
          "Details of Nonconformity": item.detailsOfNonconformity || "N/A",
          "Evidence of Non-conformity": item.evidenceOfNonconformity || "N/A",
          "Nonconformity Rating": item.nonconformityRating || "N/A",
          "Nonconformance Status": item.nonConformanceStatus || "N/A",
        }));
      }
      
    

      const previousYearData = previousYearAreas.map((item) => ({
        "Number (#)": item.number || "N/A",
        "Standard or Technical Specifications":
          item.standardOrTechnicalSpecification || "N/A",
        "Requirement Reference": item.RequirementReference || "N/A",
        "Details of Nonconformity": item.detailsOfNonconformity || "N/A",
        "Evidence of Non-conformity": item.evidenceOfNonconformity || "N/A",
        "Nonconformity Rating": item.nonconformityRating || "N/A",
        "Nonconformance Status": item.nonConformanceStatus || "N/A",
        "Corrective Action Evidence": item.evidenceOfCorrection || "N/A",
      }));

      // Add heading row for previous year if there are previous year items
    

      areasOfConcernFormattedData = [currentYearData];
      PYareasOfConcernFormattedData = [...previousYearData];
    } else {
      // For regular type, exclude evidence of correction for current year but include for previous year
      const currentYearAreas = protocolData?.areasOfConcern?.filter(item => item.isPreviousYear === false) || [];
      const previousYearAreas = protocolData?.areasOfConcern?.filter(item => item.isPreviousYear === true) || [];


      let currentYearData = [];

      if(version !== 1) {

        currentYearData = currentYearAreas.map((item) => ({
          "Number (#)": item.number || "N/A",
          "Standard or Technical Specifications":
            item.standardOrTechnicalSpecification || "N/A",
          "Requirement Reference": item.RequirementReference || "N/A",
          "Details of Nonconformity": item.detailsOfNonconformity || "N/A",
          "Evidence of Non-conformity": item.evidenceOfNonconformity || "N/A",
          "Nonconformity Rating": item.nonconformityRating || "N/A",
          "Nonconformance Status": item.nonConformanceStatus || "N/A",
          "Corrective Action Evidence": item.evidenceOfCorrection || "N/A",
        }));
      }else{
        currentYearData = currentYearAreas.map((item) => ({
          "Number (#)": item.number || "N/A",
          "Standard or Technical Specifications":
            item.standardOrTechnicalSpecification || "N/A",
          "Requirement Reference": item.RequirementReference || "N/A",
          "Details of Nonconformity": item.detailsOfNonconformity || "N/A",
          "Evidence of Non-conformity": item.evidenceOfNonconformity || "N/A",
          "Nonconformity Rating": item.nonconformityRating || "N/A",
          "Nonconformance Status": item.nonConformanceStatus || "N/A",
        }));
      }
      
      

      const previousYearData = previousYearAreas.map((item) => ({
        "Number (#)": item.number || "N/A",
        "Standard or Technical Specifications":
          item.standardOrTechnicalSpecification || "N/A",
        "Requirement Reference": item.RequirementReference || "N/A",
        "Details of Nonconformity": item.detailsOfNonconformity || "N/A",
        "Evidence of Non-conformity": item.evidenceOfNonconformity || "N/A",
        "Nonconformity Rating": item.nonconformityRating || "N/A",
        "Nonconformance Status": item.nonConformanceStatus || "N/A",
        "Corrective Action Evidence": item.evidenceOfCorrection || "N/A",
      }));

    

      areasOfConcernFormattedData = [...currentYearData];
      PYareasOfConcernFormattedData = [...previousYearData];
    }

    let fsscFindingsFormattedData;
    let PYfsscFindingsFormattedData;

    if (versioning) {
      // For versioning, include evidence of correction
      const currentYearFssc = protocolData?.ffscFindings?.filter(item => item["Is Previous Year"] === false) || [];
      const previousYearFssc = protocolData?.ffscFindings?.filter(item => item["Is Previous Year"] === true) || [];

      let currentYearData = [];

      if(version !== 1) {

        currentYearData = currentYearFssc.map((item) => ({
          "Number (#)": item["Number (#)"] || "N/A",
          "Standard or Technical Specifications":
            item["Standard or Technical Specifications"] || "N/A",
          "Requirement Reference ": item["Requirement Reference"] || "N/A",
          "Details of Nonconformity": item["Details of Nonconformity"] || "N/A",
          "Evidence of Non-conformity": item["Evidence of Non-conformity"] || "N/A",
          "Nonconformity Rating": item["Nonconformity Rating"] || "N/A",
          "NonConformance Status": item["NonConformance Status"] || "N/A",
          "Corrective Action Evidence": item["Evidence Of Correction"] || "N/A",
        }));
      }else{
        currentYearData = currentYearFssc.map((item) => ({
          "Number (#)": item["Number (#)"] || "N/A",
          "Standard or Technical Specifications":
            item["Standard or Technical Specifications"] || "N/A",
          "Requirement Reference ": item["Requirement Reference"] || "N/A",
          "Details of Nonconformity": item["Details of Nonconformity"] || "N/A",
          "Evidence of Non-conformity": item["Evidence of Non-conformity"] || "N/A",
          "Nonconformity Rating": item["Nonconformity Rating"] || "N/A",
          "NonConformance Status": item["NonConformance Status"] || "N/A",
        }));
      }
      
      

      const previousYearData = previousYearFssc.map((item) => ({
        "Number (#)": item["Number (#)"] || "N/A",
        "Standard or Technical Specifications":
          item["Standard or Technical Specifications"] || "N/A",
        "Requirement Reference ": item["Requirement Reference"] || "N/A",
        "Details of Nonconformity": item["Details of Nonconformity"] || "N/A",
        "Evidence of Non-conformity":
          item["Evidence of Non-conformity"] || "N/A",
        "Nonconformity Rating": item["Nonconformity Rating"] || "N/A",
        "NonConformance Status": item["NonConformance Status"] || "N/A",
        "Evidence Of Correction": item["Evidence Of Correction"] || "N/A",
      }));

     

      fsscFindingsFormattedData = [...currentYearData];
      PYfsscFindingsFormattedData = [...previousYearData];
    } else {
      // For regular type, exclude evidence of correction for current year but include for previous year
      const currentYearFssc = protocolData?.ffscFindings?.filter(item => item["Is Previous Year"] === false) || [];
      const previousYearFssc = protocolData?.ffscFindings?.filter(item => item["Is Previous Year"] === true) || [];

      let currentYearData = [];

      if(version !== 1) {

        currentYearData = currentYearFssc.map((item) => ({
          "Number (#)": item["Number (#)"] || "N/A",
          "Standard or Technical Specifications":
            item["Standard or Technical Specifications"] || "N/A",
          "Requirement Reference ": item["Requirement Reference"] || "N/A",
          "Details of Nonconformity": item["Details of Nonconformity"] || "N/A",
          "Evidence of Non-conformity": item["Evidence of Non-conformity"] || "N/A",
          "Nonconformity Rating": item["Nonconformity Rating"] || "N/A",
          "NonConformance Status": item["NonConformance Status"] || "N/A",
          "Corrective Action Evidence": item["Evidence Of Correction"] || "N/A",
        }));
      }else{
        currentYearData = currentYearFssc.map((item) => ({
          "Number (#)": item["Number (#)"] || "N/A",
          "Standard or Technical Specifications":
            item["Standard or Technical Specifications"] || "N/A",
          "Requirement Reference ": item["Requirement Reference"] || "N/A",
          "Details of Nonconformity": item["Details of Nonconformity"] || "N/A",
          "Evidence of Non-conformity": item["Evidence of Non-conformity"] || "N/A",
          "Nonconformity Rating": item["Nonconformity Rating"] || "N/A",
          "NonConformance Status": item["NonConformance Status"] || "N/A",
        }));
      }
     

      const previousYearData = previousYearFssc.map((item) => ({
        "Number (#)": item["Number (#)"] || "N/A",
        "Standard or Technical Specifications":
          item["Standard or Technical Specifications"] || "N/A",
        "Requirement Reference ": item["Requirement Reference"] || "N/A",
        "Details of Nonconformity": item["Details of Nonconformity"] || "N/A",
        "Evidence of Non-conformity":
          item["Evidence of Non-conformity"] || "N/A",
        "Nonconformity Rating": item["Nonconformity Rating"] || "N/A",
        "NonConformance Status": item["NonConformance Status"] || "N/A",
        "Evidence Of Correction": item["Evidence Of Correction"] || "N/A",
      }));

     

      fsscFindingsFormattedData = [...currentYearData];
      PYfsscFindingsFormattedData = [...previousYearData];
    }

    // Format Scoring Details Data

    let ffscRecommended;
    if (isCertification) {
      if (scoringData?.auditConclusion?.isFfscCertificationRecommended) {
        ffscRecommended = "Yes";
      } else {
        ffscRecommended = "No";
      }
    } else {
      ffscRecommended = "N/A";
    }

    let sendbackFfscRecommended;
    if (isCertification) {
      if (scoringData?.isFsscRecommended?.value) {
        sendbackFfscRecommended = "Yes";
      } else {
        sendbackFfscRecommended = "No";
      }
    } else {
      sendbackFfscRecommended = "N/A";
    }
    let scoringFormattedData;

    if (type === "sendback") {
      scoringFormattedData = [
        {
          "Area Opportunity":
            scoringData.auditConclusion.areaOpportunity.value || "N/A",
          "Area Strength":
            scoringData.auditConclusion.areaStrength.value || "N/A",
          "Zero Finding Justification":
            scoringData.auditConclusion.zeroFindingJustification.value || "N/A",
          "Audit Duration (Hours)":
            scoringData.auditConclusion.auditDurationHour === 0
              ? "0"
              : scoringData.auditConclusion.auditDurationHour
              ? scoringData.auditConclusion.auditDurationHour
              : "N/A",
          "Audit Duration (Minutes)":
            scoringData.auditConclusion.auditDurationMinutes === 0
              ? "0"
              : scoringData.auditConclusion.auditDurationMinutes
              ? scoringData.auditConclusion.auditDurationMinutes
              : "N/A",
          "Conformance Level":
            scoringData.auditConclusion.conformance_level || "N/A",
          "FSSC Certification Recommended": sendbackFfscRecommended,
        
          "Critical (FSSC)":
            scoringData.fsscScore[0].critical !== false
              ? scoringData.fsscScore[0].critical
              : "N/A",
          "Major (FSSC)":
            scoringData.fsscScore[0].major !== false
              ? scoringData.fsscScore[0].major
              : "N/A",
          "Minor (FSSC)":
            scoringData.fsscScore[0].minor !== false
              ? scoringData.fsscScore[0].minor
              : "N/A",
          // "Total Nonconformance Score (FSSC)": scoringData.fsscScore[0].totalNonConformanceScore || "N/A",
          "Critical (QMS)":
            scoringData.qmsScore[0].critical !== false
              ? scoringData.qmsScore[0].critical
              : "N/A",
          "Major (QMS)":
            scoringData.qmsScore[0].major !== false
              ? scoringData.qmsScore[0].major
              : "N/A",
          "Minor (QMS)":
            scoringData.qmsScore[0].minor !== false
              ? scoringData.qmsScore[0].minor
              : "N/A",
          // "Total Nonconformance Score (QMS)": scoringData.qmsScore[0].totalNonConformanceScore || "N/A"
        },
      ];
    } else {
      scoringFormattedData = [
        {
          "Area Opportunity":
            scoringData.auditConclusion.areaOpportunity || "N/A",
          "Area Strength": scoringData.auditConclusion.areaStrength || "N/A",
          "Zero Finding Justification":
            scoringData.auditConclusion.zeroFindingJustification || "N/A",
          "Audit Duration (Hours)":
            scoringData.auditConclusion.auditDurationHour === 0 ? "0" : scoringData.auditConclusion.auditDurationHour ? scoringData.auditConclusion.auditDurationHour : "N/A",
          "Audit Duration (Minutes)":
            scoringData.auditConclusion.auditDurationMinutes === 0 ? "0" : scoringData.auditConclusion.auditDurationMinutes ? scoringData.auditConclusion.auditDurationMinutes : "N/A",
          "Conformance Level":
            scoringData.auditConclusion.conformanceLevel || "N/A",
          "FSSC Certification Recommended": ffscRecommended,
   
          "Critical (FSSC)":
            scoringData.fsscScore[0].critical !== false
              ? scoringData.fsscScore[0].critical
              : "N/A",
          "Major (FSSC)":
            scoringData.fsscScore[0].major !== false
              ? scoringData.fsscScore[0].major
              : "N/A",
          "Minor (FSSC)":
            scoringData.fsscScore[0].minor !== false
              ? scoringData.fsscScore[0].minor
              : "N/A",
          // "Total Nonconformance Score (FSSC)": scoringData.fsscScore[0].totalNonConformanceScore || "N/A",
          "Critical (QMS)":
            scoringData.qmsScore[0].critical !== false
              ? scoringData.qmsScore[0].critical
              : "N/A",
          "Major (QMS)":
            scoringData.qmsScore[0].major !== false
              ? scoringData.qmsScore[0].major
              : "N/A",
          "Minor (QMS)":
            scoringData.qmsScore[0].minor !== false
              ? scoringData.qmsScore[0].minor
              : "N/A",
          // "Total Nonconformance Score (QMS)": scoringData.qmsScore[0].totalNonConformanceScore || "N/A"
        },
      ];
    }

    // Create worksheets for Audit details, Protocol details, and Scoring details
     const unitDetailSheet = XLSX.utils.json_to_sheet([formattedUnitDetails]);
    const auditSheet = XLSX.utils.json_to_sheet(auditFormattedData);
    const protocolSheet = XLSX.utils.json_to_sheet(protocolFormattedData);
    const scoringSheet = XLSX.utils.json_to_sheet(scoringFormattedData);
    const areasOfConcernSheet = XLSX.utils.json_to_sheet(
      areasOfConcernFormattedData
    );
    const fsscFindingsSheet = XLSX.utils.json_to_sheet(
      fsscFindingsFormattedData
    );
    const PYareasOfConcernSheet = XLSX.utils.json_to_sheet(
      PYareasOfConcernFormattedData
    );
    const PYfsscFindingsSheet = XLSX.utils.json_to_sheet(
      PYfsscFindingsFormattedData
    );

    // Set column widths
    unitDetailSheet["!cols"] = unitDetailsCols;
    auditSheet["!cols"] = auditCols;
    protocolSheet["!cols"] = protocolCols;
    areasOfConcernSheet["!cols"] = areasOfConcernsCols;
    fsscFindingsSheet["!cols"] = fsscFindngCols;
    PYareasOfConcernSheet["!cols"] = areasOfConcernsCols;
    PYfsscFindingsSheet["!cols"] = fsscFindngCols;

    // Add styles to sheets
    addStyles(unitDetailSheet, color);
    addStyles(auditSheet, color);
    addStyles(protocolSheet, color);
    addStyles(scoringSheet, color);
    addStyles(areasOfConcernSheet, color);
    addStyles(PYareasOfConcernSheet, color);
    addStyles(fsscFindingsSheet, color);  
    addStyles(PYfsscFindingsSheet, color);
    // Create the workbook with all sheets
    const wb = {
      Sheets: {
        [sheetNames[0]]: unitDetailSheet,
        [sheetNames[1]]: auditSheet, // Audit details
        [sheetNames[2]]: protocolSheet, // Protocol details
        [sheetNames[3]]: scoringSheet, // Scoring details
        [sheetNames[4]]: areasOfConcernSheet, // Area Of concerns
        [sheetNames[5]]: PYareasOfConcernSheet, // PY area of concerns
        [sheetNames[6]]: fsscFindingsSheet, // fssc finding sheet
        [sheetNames[7]]: PYfsscFindingsSheet, // PY fssc finding sheet
      },
      SheetNames: [
        sheetNames[0],
        sheetNames[1],
        sheetNames[2],
        sheetNames[3],
        sheetNames[4],
        sheetNames[5],
        sheetNames[6],
        sheetNames[7],
      ],
    };

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });

    // Optional: Add timestamp to the filename
    const timestamp = new Date().toISOString().split("T")[0]; // For example: 2025-03-08
    FileSaver.saveAs(data, `${fileName}-${timestamp}${fileExtension}`);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
        position: exportPosition ? "absolute" : "unset",
        top: "10px",
        right: "12px",
      }}
      title="Export in Excel"
      onClick={exportToExcel}
      className={`${className} bg-orange-500 text-white px-4 py-2 rounded-md hover:bg-orange-600 transition duration-300` }

    >
      <FaDownload color="#ffffff" size={14} />
      <p
        style={{
          marginBottom: "0",
          color: "#ffffff",
          fontSize: "14px",
          fontWeight: "500",
        }}
      >
        Export Data
      </p>
    </div>
  );
};

export default AuditProtocolScoringExcel;
